<template>
    <div id="home" class="c-main-scroll window-width window-height" :style="'height:'+heightPX+'px !important'">
        <div class="main overflow-hidden relative-position" style="width: 100%;min-width: 1440px;">
            <searchLeagueTeam></searchLeagueTeam>
            <myheader></myheader>
            <contentsBody></contentsBody>
            <!-- <contentsRight></contentsRight> -->
            <!--div class="fadein">
                <div class="popup-image auto-height">
                    <div class="guide-close-button header-title">
                        <label>{{ lang.newFeature }}</label>
                        <i class="fa fa-times-circle fa-2x" @click="closeGuide"></i>
                    </div>
                    <div class="message">
                        <span v-html="lang.chipStep1"></span><br />
                        <span v-html="lang.chipStep2"></span>
                    </div>
                    <img :src="customImage.home_guide + '_' + chooseLang + customImage.home_guide_extension"
                        class="margin-image">
                </div>
            </div-->
            <!--  && checkMiniBetUnique(event, getOddUniqueId(event))" -->
            <minibet v-if="sportMiniBet.toggle && miniNormal=='1'"></minibet>

            <div v-if="comboBetExceedLimit" role="dialog" aria-modal="false" class="q-dialog fullscreen no-pointer-events q-dialog--seamless">
                <div tabindex="-1" class="q-dialog__inner flex no-pointer-events q-dialog__inner--minimized q-dialog__inner--standard fixed-full flex-center">
                    <div class="dialog_content q-card">
                        <div class="q-card__section-dialog q-card__section--vert">
                            <div class="text-h6">
                                <img src="assets/images/warn.svg">
                            </div>{{ lang.home['HOME.HIT_MAX_COMBO'] }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="dialogToggle.show" role="dialog" aria-modal="false" class="q-dialog fullscreen no-pointer-events q-dialog--seamless">
                <div tabindex="-1" class="q-dialog__inner flex no-pointer-events q-dialog__inner--minimized q-dialog__inner--standard fixed-full flex-center">
                    <div class="dialog_content q-card">
                        <div class="q-card__section-dialog q-card__section--vert">
                            <div class="text-h6">
                                <img src="assets/images/warn.svg">
                            </div>{{ dialogToggle.msg }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- betting mode: simple soccer / standard -->
            <div v-if="bettingModeAlert" class="fullscreen bet_mode_dialog" style="z-index: 1000 !important;">
                <div class="popmask">
                    <div>
                        <div class="uiimg_bg">
                            <div class="iselect-title">{{ lang.home['HOME.BETTING_MODE'] }}</div>
                            <div class="iselect_area">
                                <div href="#" class="am_ed iselect" :class="{ on: bettingMode==null }" @click="betMode(null)">
                                    <font class="iselect-title-s">{{ lang.home['HOME.STANDARD'] }}</font><br>
                                    <img class="iselect-img" src="" alt="">
                                </div>
                                <div href="#" class="am_i iselect" :class="{ on: bettingMode=='N1' }" @click="betMode('N1')">
                                    <font class="iselect-title-s">{{ lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'] }}</font><br>
                                    <img class="iselect-img" src="" alt="">
                                </div>
                            </div>
                            <div><div class="sbtn" @click="confirmBetMode()">{{ lang.home['HOME.GET_STARTED'] }}</div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="hasRedirect" class="fullscreen login-redirect-dialog" style="z-index:1000px !important;display:none;">
                <div class="dialog">
                    <div>
                        <div class="dialog-content">
                            <div class="dialog-title">{{ lang.to_login }}</div>
                            <div class="dialog-message">{{ lang.to_login_message }}</div>
                            <div class="dialog-button">
                                <button type="submit" class="btn btn-cancel" tabindex="3" @click.prevent="redirectDialogAction('cancel')">{{ ((loginRedirectUrl) ? lang.cancel : lang.ok) }}</button>
                                <button v-if="loginRedirectUrl" type="submit" class="btn btn-submit" tabindex="3" @click.prevent="redirectDialogAction('login')">{{ lang.login }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vueCookie from 'vue-cookie'
import moment from 'moment'
import searchLeagueTeam from './contentsMain/searchLeagueTeam'
import myheader from './myheader/wob_index'
import contentsBody from './contentsMain/index'
// import contentsRight from './contentsRight/index'
import minibet from '@/vue/components/mini-bet'
import EventBus from '../../events/event-bus'

import {
    mapGetters
} from 'vuex'

export default {
    components: {
        myheader,
        contentsBody,
        searchLeagueTeam,
        minibet,
        //   contentsRight
    },
    data() {
        return {
            lang: window.lang,
            chooseLang: window._cookie,
            customImage: window._customImage,
            token: window.token,
	        heightPX: window.innerHeight + 'px',
	        bettingModeAlert: window.bettingModeAlert,
	        def_edition: window.def_edition,
	        def_theme: window.def_theme,
	        bettingMode: 'N1',
            lobby: window.lobby,
            lobbyUrl: window.lobbyUrl,
            hasRedirect: window._hasRedirect,
            loginRedirectUrl: window._loginRedirectUrl,
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'selectedBettype',
            'showLeagueTeam',
            'unfold_AllSc',
            'miniNormal',
            'frameWidthHeight',
            'sportMiniBet',
            'comboBetExceedLimit',
            'dialogToggle',
        ]),
        LeftMenu_heightPX: function () {
            return this.$store.getters.frameWidthHeight.height.currentHeight
        },
        current_widthPX: function () {
            return this.$store.getters.frameWidthHeight.width.currentWidth
        },
    },
    methods: {
        closeGuide() {
            $('.fadein').fadeOut();
            var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
            accCookie.shownGuide = true
            // vueCookie.set(window.compcode + '_acc', JSON.stringify(accCookie))
            $.ajax({
                method: 'post',
                url: _baseUrl + '/callCookies',
                data: {
                    com_code: window.compcode,
                    acc: JSON.stringify(accCookie),
                },
            }).done((res) => {

            })
        },
        onResize() {
            let resizeable={};
            if(this.LeftMenu_heightPX!=window.innerHeight){
                resizeable.currentHeight=window.innerHeight
            }
            if(this.current_widthPX!=window.innerWidth){
                resizeable.currentWidth=window.innerWidth
            }
            if(resizeable){
                this.$store.commit('FRAME_WH', resizeable)
            }
        },
        betMode(mode) {
            this.bettingMode = mode
        },
        confirmBetMode() {
            this.bettingModeAlert = false
            if(this.bettingMode != null) {
                this.setSimpleSoccer(this.bettingMode)
                $.ajax({
                    url: _baseUrl + '/account-def-settings',
                    type: 'get',
                    data: {
                        action: 'updateAccountSportSetting',
                        edition: 3,
                        startedtab: 1,
                        sport_id: this.bettingMode.substring(1)
                    }
                }).done(response => {
                })
            }
        },
        setSimpleSoccer(bettingMode) {
            if(this.$store.getters.sportList && this.$store.getters.sportList.length > 0) {
                var sindex = _.findIndex(this.$store.getters.sportList, { 'sprtId': bettingMode })
                if(sindex!=-1) {
                    if(this.$store.getters.allSportCount) {
                        if((this.$store.getters.allSportCount['today'] && this.$store.getters.allSportCount['today'][bettingMode] && Object.keys(this.$store.getters.allSportCount['today'][bettingMode]).length > 0)
                            || (this.$store.getters.allSportCount['live'] && this.$store.getters.allSportCount['live'][bettingMode] && Object.keys(this.$store.getters.allSportCount['live'][bettingMode]).length > 0)) {
                            if(this.$store.getters.selectedMarket != this.$store.getters.market.tdyMarket.key){
                                this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key)
                            }
                        } else if(this.$store.getters.allSportCount['early'] && this.$store.getters.allSportCount['early'][bettingMode] && Object.keys(this.$store.getters.allSportCount['early'][bettingMode]).length > 0) {
                            if(this.$store.getters.selectedMarket != this.$store.getters.market.earlyMarket.key){
                                this.$store.commit('SELECTED_MARKET', this.$store.getters.market.earlyMarket.key)
                            }
                        }
                    }
                    EventBus.$emit('changeSimpleSport',this.$store.getters.sportList[sindex])
                }
            }
        },
        redirectDialogAction(action) {
            if (action == 'cancel') {
                $('.login-redirect-dialog').hide();
            } else if (action == 'login') {
                window.parent.location.href = this.loginRedirectUrl;
            }
        }
    },
    mounted() {
        $('#loading-root-ele').hide()
        // if (vueCookie.get(window.compcode + '_acc')) {
        //     var accCookie = JSON.parse(vueCookie.get(window.compcode + '_acc'))
        //     if (!accCookie.shownGuide && this.customImage.home_guide_upload_date) {
        //         if (this.customImage.home_guide_upload_date) {
        //             var uploadDate = moment(this.customImage.home_guide_upload_date)
        //             var lastLoginDate = moment(this.account.lastLogin)
        //             if (accCookie.afterFirstLogin == true || moment(uploadDate.valueOf()).isSameOrAfter(lastLoginDate.valueOf())) {
        //                 $(".fadein").fadeIn();
        //             }
        //         }
        //     }
        // }
        let Vue=this;
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
            var lastScrollLeft = 0;
            $('#home').scroll(function() {
                var documentScrollLeft = $('#home').scrollLeft();
                if (lastScrollLeft != documentScrollLeft) {
                    $('#leftBarMiniScroll').hide();
                    $('#leftBarNormalScroll').hide();
                    $('#AllBetScrollab').hide();
                    var lefpos=  (60-documentScrollLeft)<0? -5: (60-documentScrollLeft)
                    var lefpos2=  (225-documentScrollLeft)<0? -5: (225-documentScrollLeft)
                    var lefpos3=  (998-documentScrollLeft)<0? -5: (998-documentScrollLeft)
                    $('#leftBarMiniScroll').css({left: lefpos});
                    $('#leftBarNormalScroll').css({left: lefpos2});
                    $('#AllBetScrollab').css({left: lefpos3});
                    setTimeout(function(){
                        if(Vue.$store.getters.miniNormal==1){
                            $('#leftBarMiniScroll').show()
                            $("leftBarMiniScroll").getNiceScroll().resize();
                        }else{
                            $('#leftBarNormalScroll').show()
                            $("leftBarNormalScroll").getNiceScroll().resize();
                        }
                        $('#AllBetScrollab').show()
                    }, 1000);
              
                    if(documentScrollLeft + $('#home').width() == $('.main').width()){
                        $('#AllBetScrollfirstEvent').show();
                    }else{
                        $('#AllBetScrollfirstEvent').hide();
                    }
                    //console.log(documentScrollLeft)
                    lastScrollLeft = documentScrollLeft;
                }
            });
        })

        if(this.def_edition == 3 && !this.bettingModeAlert) {
            this.setSimpleSoccer('N1')
        }
    },
    beforeMount() {
       // console.log(vueCookie.get('theme'))
        if(vueCookie.get('theme') == 'theme02') {
            document.documentElement.classList.add('theme02');
        }else{
            document.documentElement.classList.remove('theme02');
        }
        this.$store.commit('FRAME_RESIZE', 1);
        // if got promotion set data
        if(window.promotion_data != false && window.promotion_data != null){
            this.$store.dispatch('setPromoDetails', {
                promo_details: window.promotion_data,
                promotionBetStatus: window.promotionBetStatus,
            })
        }
    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },
}
</script>
<style lang="scss">
//@import "~@/styles/base/global";
@import "~@/styles/home/vapp";
@import "~@/styles/home/app";
@import "~@/styles/sport/sportTable";
@import "~@/styles/home/details-miniChunk";
@import "~@/styles/home/miniChunk";
@import "~@/styles/home/details";

@import "~@/styles/home/main";
@import "~@/styles/home/other";
@import "~@/styles/home/sport";
@import "~@/styles/home/account";
@import "~@/styles/home/promotion";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/home.vue